module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/4-b13614002d091abe6cca9e02c5c9d79e.webp";